import { DotsLoader } from "./DotsLoader"
import { SpinnerLoader } from "./SpinnerLoader"

const Loader = {
  Dots: DotsLoader,
  Spinner: SpinnerLoader,
}
export { Loader }
